import { LastOnlineStatusBadge } from 'gcs-common/components/LastOnlineStatusBadge/LastOnlineStatusBadge';
import FeatureFlagProtectedRoute from 'gcs-common/components/ProtectedRoutes/FeatureFlagProtectedRoute';
import FEATURE_FLAGS from 'gcs-common/helper/featureFlagsHelper';
import { ONLINE_STATUS } from 'gcs-common/helper/userStatusHelper';
import { getChannelStatusRelevantUserId } from 'gcs-common/slices/channel/channelSelectors';
import { getIsAgent } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { getUserIsAgent, getUserStatus } from 'gcs-common/slices/user/userSelectors';
import { useSelector } from 'react-redux';

export function ChatNavBarLastOnlineStatusBadge({ selectedChannelId }: { selectedChannelId: string }) {
  const currentUserIsAgent = useSelector(getIsAgent);
  const channelStatusUserId = useSelector(getChannelStatusRelevantUserId(selectedChannelId)) as string;
  const channelStatusUserIsAgent = useSelector(getUserIsAgent(channelStatusUserId));
  const channelStatus = useSelector(getUserStatus(channelStatusUserId));

  const showBadge = !channelStatusUserIsAgent && channelStatus.type !== ONLINE_STATUS.ONLINE && currentUserIsAgent;

  if (!showBadge) {
    return null;
  }

  return (
    <FeatureFlagProtectedRoute enabledFlag={FEATURE_FLAGS.LAST_ONLINE_BADGE_ENABLED}>
      <LastOnlineStatusBadge userStatus={channelStatus} hideLabel />
    </FeatureFlagProtectedRoute>
  );
}
